import Fuse from 'fuse.js';
export default {
  computed: {
    pagedData() {
      return this.tableData.slice(this.from, this.to);
    },
    /***
     * Searches through table data and returns a paginated array.
     * Note that this should not be used for table with a lot of data as it might be slow!
     * Do the search and the pagination on the server and display the data retrieved from server instead.
     * @returns {computed.pagedData}
     */
    queriedData() {
      if (!this.searchQuery) {
        return this.pagedData;
      }
      let result = this.tableData.filter((row) => {
        let isIncluded = false;
        for (let key of this.propsToSearch) {
          if(key.includes('.')){
              let arrays = key.split('.')
              var rowValue = null;
              // support up to 3 nested attributes
              switch(arrays.length) {
                case 1:
                  rowValue = row[arrays[0]]
                  break
                case 2:
                  if(row[arrays[0]]){
                    rowValue = row[arrays[0]][arrays[1]]
                  }
                  break;
                case 3:
                  if(row[arrays[0]] && row[arrays[1]]){
                    rowValue = row[arrays[0]][arrays[1]][arrays[2]]
                  }
                  break;
              }
            if(rowValue){
              rowValue = rowValue.toString().toLowerCase();
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true;
              }
            }
          }else{
            if(row[key]){
              var rowValue = row[key].toString().toLowerCase();
              if (rowValue.includes && rowValue.includes(this.searchQuery.toLowerCase())) {
                isIncluded = true;
              }
            }
          }
        }
        return isIncluded;
      });

      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.tableData.length;
    },
  },
  data() {
    return {
      pagination: {
        perPage: 50,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50],
        total: 0,
        from: 0,
        to: 0,
      },
      searchQuery: '',
      searchedData: [],
      fuseSearch: ''
    }
  },
  methods: {
    sortChange({ prop, order }) {
      if (prop) {
        this.tableData.sort((a, b) => {
          let aVal = a[prop]
          let bVal = b[prop]
          if (order === 'ascending') {
            return aVal > bVal ? 1 : -1
          }
          return bVal - aVal ? 1 : -1
        })
      } else {
        this.tableData.sort((a, b) => {
          return a.id - b.id
        })
      }
    }
  },

}
